// LoginModal.tsx
import React from 'react';
import { useAuth } from './AuthContext';
import AuthModal from '../features/AuthModal';

const LoginModal: React.FC = () => {
  const { showLoginModal, setShowLoginModal, logout } = useAuth();


  if (!showLoginModal) return null;

  return (
    <AuthModal isOpen={showLoginModal} onClose={() => {logout(); setShowLoginModal(false); }} onLogin={() => {}} onSignup={() => setShowLoginModal(false)}/>
  );
};

export default LoginModal;
